import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { NgForm } from '@angular/forms'

@Component({
  selector: 'add-object-form',
  templateUrl: './addObjectForm.component.pug',
  styleUrls: ['./addObjectForm.component.scss'],
})
export class AddObjectFormComponent {
  @Input() verb?: string
  @Input() placeholder?: string
  @Output('submitted') submitEvent = new EventEmitter<string>()
  @ViewChild('form', { 'static': false }) form: NgForm

  value = ''

  submit () {
    this.value = this.value.trim()
    if (!this.form.form.valid || !this.value) {
      return
    }
    this.submitEvent.next(this.value)
    this.value = ''
    this.form.resetForm()
  }
}
